/* global axios */
import WhatsAppSipApiClient from './index';

class WhatsAppSipMyExtensionAPI extends WhatsAppSipApiClient {
  constructor() {
    super('my_extension');
  }

  // GET /api/v1/accounts/:account_id/whatsapp_sip/my_extension
  get() {
    return axios.get(this.url);
  }
}

export default new WhatsAppSipMyExtensionAPI();
